import {updateFactory, Dispatch, AnyAction} from '@modifi/redux'
import {getAuthenticatedAdminThemisClient} from '@modifi/onboarding-api-clients'
import {aAddSnackBar} from '@modifi/plugin-snackbars'

import {keyWindowFromUrlForTasks} from '../../../utils/keyWindowFromUrl'
import {AppThunkAction} from '../../../types/redux'
import {aFetchTasksWithParams} from '../../../data/tasks'

const apiClient = getAuthenticatedAdminThemisClient()

const aFetchTasksWithUrlParams =
  (): AppThunkAction<void> =>
  (dispatch, getState): void => {
    const params = keyWindowFromUrlForTasks(getState())
    if (Object.keys(params).length > 0 && !Number.isNaN(params?.pageIndex)) {
      dispatch(aFetchTasksWithParams(params))
    } else {
      // eslint-disable-next-line no-console
      console.warn('trying to fetch tasks with invalid params', JSON.stringify(params))
    }
  }

const {actions, reducer} = updateFactory({
  rootSelector: state => state?.pages?.assignTaskToAccountOwner,
  actionNamePrefix: 'pages/tasks/assignToAccountOwner',
  submitRequest:
    (a, externalTaskId: string, externalCompanyId: string, actionMessage?: string) =>
    async (dispatch: Dispatch): Promise<void> => {
      dispatch(a.pendingAction())
      try {
        await apiClient.Company.assignTaskToAccountOwner({externalTaskId, externalCompanyId})
      } catch (e: any) {
        dispatch(a.errorAction(e))
        const errorMessage = e?.data()?.errorMessage

        dispatch(
          aAddSnackBar({
            type: 'alert',
            message: errorMessage || 'failed',
          }) as unknown as AnyAction
        )
        return
      }

      dispatch(aFetchTasksWithUrlParams() as unknown as AnyAction)
      dispatch(a.successAction())
      actionMessage &&
        dispatch(
          aAddSnackBar({
            type: 'info',
            message: actionMessage,
          }) as unknown as AnyAction
        )
    },
})

export default reducer
export const {aSubmit: aAssignTaskToAccountOwner} = actions
